<div class="form-group d-flex" style="gap: 15px;margin-bottom: 10px;">
  <div *ngFor="let item of names; let i = index" class="form-check form-check-inline">
    <input
      class="form-check-input checkbox-solid-info"
      type="checkbox"
      [id]="'checkbox-' + i"
      [(ngModel)]="selectedValues[item.id]"
      (change)="onChange(item)"
      [disabled]="disable"
    />
    <label class="form-check-label" [for]="'checkbox-' + i">
      {{ item.name }}
    </label>
  </div>
</div>
<div *ngIf="showRequiredError" class="text-danger">
  Choose one option before submitting the form
</div>
